import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { DASHBOARD, LOGIN } from '../constants/routes';
import { hasPermission } from '../utilities/helpers';

const requireAuth = (ChildComponent, requiredPermissions = []) =>
  function checkAuth() {
    const role = useSelector((state) => get(state, 'auth.role'));
    const isLoggedIn = useSelector((state) =>
      get(state, 'auth.isLoggedIn', false)
    );

    if (
      get(role, 'permissions', []).length &&
      !hasPermission(get(role, 'permissions', []), requiredPermissions)
    ) {
      return <Redirect to={DASHBOARD} />;
    }

    if (!isLoggedIn) {
      return <Redirect to={LOGIN} />;
    }
    return <ChildComponent />;
  };

export default requireAuth;
